import {OpcoesBrf} from "../core/utils/elegivelBrf";

export interface FiltroEmbarqueCompleto {
    aceite?: string[];
    adiantamento?: string[];
    adicionalEmpresa?: string[];
    adicionalMotorista?: string[];
    agregado?: boolean | null;
    cancelado?: boolean | null;
    cte?: string[];
    cidadeDestino?: string[];
    cidadeDestinoIds?: number[];
    cidadeOrigem?: string[];
    cidadeOrigemIds?: number[];
    classificacao?: string[];
    cliente?: string[];
    clienteIds?: number[];
    contexto?: string;
    dataHoraChegadaEmbarqueFim?: string;
    dataHoraChegadaEmbarqueInicio?: string;
    dataHoraChegadaEntregaFim?: string;
    dataHoraChegadaEntregaInicio?: string;
    dataHoraEmbarcadoFim?: string;
    dataHoraEmbarcadoInicio?: string;
    dataHoraEntregueFim?: string;
    dataHoraEntregueInicio?: string;
    diariaExcedida?: boolean | null;
    embalagem?: string[];
    embarcador?: string[];
    embarcadorIds?: number[];
    elegibilidadeBrf?: OpcoesBrf[];
    tipoProprietario: number[],
    empresa?: string[];
    empresaIds?: number[];
    filial?: string[];
    filialIds?: number[];
    freteFiscal?: string[];
    freteMotorista?: string[];
    frota?: boolean | null;
    icms?: string[];
    km?: string[];
    load?: string[];
    margem?: string[];
    meioPagamento?: string[];
    meioPagamentoIds?: number[];
    mercadoria?: string[];
    mercadoriaIds?: number[];
    motorista?: string[];
    motoristaIds?: number[];
    motivo?: string[];
    observacao?: string[];
    pedido?: string[];
    pedidoIds?: number[];
    pedagio?: string[];
    peso?: string[];
    pisoExcedido?: boolean | null;
    placaCarreta?: string[];
    placaCarreta2?: string[];
    placaCarreta2Ids?: number[];
    placaCarretaIds?: number[];
    placaCavalo?: string[];
    placaCavaloIds?: number[];
    previsaoEmbarqueFim?: string;
    previsaoEmbarqueInicio?: string;
    previsaoEntregaFim?: string;
    previsaoEntregaInicio?: string;
    proprietario?: string[];
    proprietarioIds?: number[];
    saldo?: string[];
    status?: string[];
    statusIds?: number[];
    tipoCarroceria?: string[];
    tipoCarroceriaIds?: number[];
    tipoVeiculo?: string[];
    tipoVeiculoIds?: number[];
    telemetria?: boolean | null;
    unidEmbarque?: string[];
    unidEmbarqueEmbarqueIds?: number[];
    unidEmbarqueEmbarqueNome?: string[];
    unidEmbarqueIds?: number[];
    valorGeral?: string;
}

export enum FiltroEmbarqueCompletoEnum {
    Aceite = "aceite",
    Adiantamento = "adiantamento",
    AdicionalEmpresa = "adicionalEmpresa",
    AdicionalMotorista = "adicionalMotorista",
    Agregado = "agregado",
    Cancelado = "cancelado",
    CidadeDestino = "cidadeDestino",
    CidadeDestinoIds = "cidadeDestinoIds",
    CidadeOrigem = "cidadeOrigem",
    CidadeOrigemIds = "cidadeOrigemIds",
    Classificacao = "classificacao",
    Cliente = "cliente",
    ClienteIds = "clienteIds",
    Contexto = "contexto",
    Cte = "cte",
    DataHoraChegadaEmbarqueFim = "dataHoraChegadaEmbarqueFim",
    DataHoraChegadaEmbarqueInicio = "dataHoraChegadaEmbarqueInicio",
    DataHoraChegadaEntregaFim = "dataHoraChegadaEntregaFim",
    DataHoraChegadaEntregaInicio = "dataHoraChegadaEntregaInicio",
    DataHoraEmbarcadoFim = "dataHoraEmbarcadoFim",
    DataHoraEmbarcadoInicio = "dataHoraEmbarcadoInicio",
    DataHoraEntregueFim = "dataHoraEntregueFim",
    DataHoraEntregueInicio = "dataHoraEntregueInicio",
    DiariaExcedida = "diariaExcedida",
    ElegibilidadeBrf = "elegibilidadeBrf",
    TipoProprietario = "tipoProprietario",
    Embalagem = "embalagem",
    Empresa = "empresa",
    EmpresaIds = "empresaIds",
    Filial = "filial",
    FilialIds = "filialIds",
    FreteFiscal = "freteFiscal",
    FreteMotorista = "freteMotorista",
    Frota = "frota",
    Icms = "icms",
    Km = "km",
    Load = "load",
    Margem = "margem",
    MeioPagamento = "meioPagamento",
    MeioPagamentoIds = "meioPagamentoIds",
    Mercadoria = "mercadoria",
    MercadoriaIds = "mercadoriaIds",
    Motorista = "motorista",
    MotoristaIds = "motoristaIds",
    Motivo = "motivo",
    Observacao = "observacao",
    Pedagio = "pedagio",
    Pedido = "pedido",
    PedidoIds = "pedidoIds",
    Peso = "peso",
    PisoExcedido = "pisoExcedido",
    PlacaCarreta = "placaCarreta",
    PlacaCarreta2 = "placaCarreta2",
    PlacaCarreta2Ids = "placaCarreta2Ids",
    PlacaCarretaIds = "placaCarretaIds",
    PlacaCavalo = "placaCavalo",
    PlacaCavaloIds = "placaCavaloIds",
    PrevisaoEmbarqueFim = "previsaoEmbarqueFim",
    PrevisaoEmbarqueInicio = "previsaoEmbarqueInicio",
    PrevisaoEntregaFim = "previsaoEntregaFim",
    PrevisaoEntregaInicio = "previsaoEntregaInicio",
    Proprietario = "proprietario",
    ProprietarioIds = "proprietarioIds",
    Saldo = "saldo",
    Status = "status",
    StatusIds = "statusIds",
    TipoCarroceria = "tipoCarroceria",
    TipoCarroceriaIds = "tipoCarroceriaIds",
    TipoVeiculo = "tipoVeiculo",
    TipoVeiculoIds = "tipoVeiculoIds",
    Telemetria = "telemetria",
    UnidEmbarque = "unidEmbarque",
    UnidEmbarqueEmbarqueIds = "unidEmbarqueEmbarqueIds",
    UnidEmbarqueEmbarqueNome = "unidEmbarqueEmbarqueNome",
    UnidEmbarqueIds = "unidEmbarqueIds",
    ValorGeral = "valorGeral",
}

export enum FiltroEmbarqueCompletoTitles {
    Aceite = "Aceite",
    Adiantamento = "Adiantamento",
    AdicionalEmpresa = "Adicional Empresa",
    AdicionalMotorista = "Adicional Motorista",
    Agregado = "Agregado",
    Cancelado = "Cancelado",
    CidadeDestino = "Cidade Destino",
    CidadeOrigem = "Cidade Origem",
    Classificacao = "Classificação",
    Cliente = "Cliente",
    Cte = "CTE",
    Embalagem = "Embalagem",
    Empresa = "Empresa",
    FreteFiscal = "Frete Fiscal",
    FreteMotorista = "Frete Motorista",
    Filial = "Filial",
    Frota = "Frota",
    Icms = "ICMS",
    Km = "KM",
    Load = "Load",
    Margem = "Margem",
    MeioPagamento = "Meio de Pagamento",
    Mercadoria = "Mercadoria",
    Motorista = "Motorista",
    Motivo = "Motivo",
    Observacao = "Observação",
    Pedagio = "Pedágio",
    Pedido = "Pedido",
    Peso = "Peso",
    PisoExcedido = "Piso Excedido",
    PlacaCarreta = "Placa Carreta",
    PlacaCarreta2 = "Placa Carreta 2",
    PlacaCavalo = "Placa Cavalo",
    Proprietario = "Proprietário",
    Saldo = "Saldo",
    Status = "Status",
    TipoCarroceria = "Tipo de Carroceria",
    TipoVeiculo = "Tipo de Veículo",
    Telemetria = "Telemetria",
    UnidadeEmbarque = "Unidade de Embarque",
    UnidadeEmbarqueNome = "Unidade de Embarque Nome",
    ValorGeral = "Valor Geral",
}

export const emptyFiltroEmbarqueCompleto: FiltroEmbarqueCompleto = {
    [FiltroEmbarqueCompletoEnum.Aceite]: [],
    [FiltroEmbarqueCompletoEnum.Adiantamento]: [],
    [FiltroEmbarqueCompletoEnum.AdicionalEmpresa]: [],
    [FiltroEmbarqueCompletoEnum.AdicionalMotorista]: [],
    [FiltroEmbarqueCompletoEnum.Agregado]: null,
    [FiltroEmbarqueCompletoEnum.Cancelado]: null,
    [FiltroEmbarqueCompletoEnum.Classificacao]: [],
    [FiltroEmbarqueCompletoEnum.Cliente]: [],
    [FiltroEmbarqueCompletoEnum.ClienteIds]: [],
    [FiltroEmbarqueCompletoEnum.Contexto]: "",
    [FiltroEmbarqueCompletoEnum.Cte]: [],
    [FiltroEmbarqueCompletoEnum.DataHoraChegadaEmbarqueFim]: "",
    [FiltroEmbarqueCompletoEnum.DataHoraChegadaEmbarqueInicio]: "",
    [FiltroEmbarqueCompletoEnum.DataHoraChegadaEntregaFim]: "",
    [FiltroEmbarqueCompletoEnum.DataHoraChegadaEntregaInicio]: "",
    [FiltroEmbarqueCompletoEnum.DataHoraEmbarcadoFim]: "",
    [FiltroEmbarqueCompletoEnum.DataHoraEmbarcadoInicio]: "",
    [FiltroEmbarqueCompletoEnum.DataHoraEntregueFim]: "",
    [FiltroEmbarqueCompletoEnum.DataHoraEntregueInicio]: "",
    [FiltroEmbarqueCompletoEnum.DiariaExcedida]: null,
    [FiltroEmbarqueCompletoEnum.ElegibilidadeBrf]: [],
    [FiltroEmbarqueCompletoEnum.TipoProprietario]: [],
    [FiltroEmbarqueCompletoEnum.Embalagem]: [],
    [FiltroEmbarqueCompletoEnum.Empresa]: [],
    [FiltroEmbarqueCompletoEnum.EmpresaIds]: [],
    [FiltroEmbarqueCompletoEnum.Filial]: [],
    [FiltroEmbarqueCompletoEnum.FilialIds]: [],
    [FiltroEmbarqueCompletoEnum.FreteFiscal]: [],
    [FiltroEmbarqueCompletoEnum.FreteMotorista]: [],
    [FiltroEmbarqueCompletoEnum.Frota]: null,
    [FiltroEmbarqueCompletoEnum.Icms]: [],
    [FiltroEmbarqueCompletoEnum.Km]: [],
    [FiltroEmbarqueCompletoEnum.Load]: [],
    [FiltroEmbarqueCompletoEnum.Margem]: [],
    [FiltroEmbarqueCompletoEnum.MeioPagamento]: [],
    [FiltroEmbarqueCompletoEnum.MeioPagamentoIds]: [],
    [FiltroEmbarqueCompletoEnum.Mercadoria]: [],
    [FiltroEmbarqueCompletoEnum.MercadoriaIds]: [],
    [FiltroEmbarqueCompletoEnum.Motorista]: [],
    [FiltroEmbarqueCompletoEnum.MotoristaIds]: [],
    [FiltroEmbarqueCompletoEnum.Motivo]: [],
    [FiltroEmbarqueCompletoEnum.Observacao]: [],
    [FiltroEmbarqueCompletoEnum.Pedagio]: [],
    [FiltroEmbarqueCompletoEnum.Pedido]: [],
    [FiltroEmbarqueCompletoEnum.PedidoIds]: [],
    [FiltroEmbarqueCompletoEnum.Peso]: [],
    [FiltroEmbarqueCompletoEnum.PisoExcedido]: null,
    [FiltroEmbarqueCompletoEnum.PlacaCarreta]: [],
    [FiltroEmbarqueCompletoEnum.PlacaCarreta2]: [],
    [FiltroEmbarqueCompletoEnum.PlacaCarreta2Ids]: [],
    [FiltroEmbarqueCompletoEnum.PlacaCarretaIds]: [],
    [FiltroEmbarqueCompletoEnum.PlacaCavalo]: [],
    [FiltroEmbarqueCompletoEnum.PlacaCavaloIds]: [],
    [FiltroEmbarqueCompletoEnum.PrevisaoEmbarqueFim]: "",
    [FiltroEmbarqueCompletoEnum.PrevisaoEmbarqueInicio]: "",
    [FiltroEmbarqueCompletoEnum.PrevisaoEntregaFim]: "",
    [FiltroEmbarqueCompletoEnum.PrevisaoEntregaInicio]: "",
    [FiltroEmbarqueCompletoEnum.Proprietario]: [],
    [FiltroEmbarqueCompletoEnum.ProprietarioIds]: [],
    [FiltroEmbarqueCompletoEnum.Saldo]: [],
    [FiltroEmbarqueCompletoEnum.Status]: [],
    [FiltroEmbarqueCompletoEnum.StatusIds]: [],
    [FiltroEmbarqueCompletoEnum.TipoCarroceria]: [],
    [FiltroEmbarqueCompletoEnum.TipoCarroceriaIds]: [],
    [FiltroEmbarqueCompletoEnum.TipoVeiculo]: [],
    [FiltroEmbarqueCompletoEnum.TipoVeiculoIds]: [],
    [FiltroEmbarqueCompletoEnum.Telemetria]: null,
    [FiltroEmbarqueCompletoEnum.UnidEmbarque]: [],
    [FiltroEmbarqueCompletoEnum.UnidEmbarqueEmbarqueIds]: [],
    [FiltroEmbarqueCompletoEnum.UnidEmbarqueEmbarqueNome]: [],
    [FiltroEmbarqueCompletoEnum.UnidEmbarqueIds]: [],
    [FiltroEmbarqueCompletoEnum.ValorGeral]: "",
};

export const stringFiltroEmbarque: {
    key1: FiltroEmbarqueCompletoEnum;
    title1: FiltroEmbarqueCompletoTitles;
    key2: FiltroEmbarqueCompletoEnum;
    title2: FiltroEmbarqueCompletoTitles;
}[] = [
    {
        key1: FiltroEmbarqueCompletoEnum.Aceite,
        title1: FiltroEmbarqueCompletoTitles.Aceite,
        key2: FiltroEmbarqueCompletoEnum.Adiantamento,
        title2: FiltroEmbarqueCompletoTitles.Adiantamento,
    },
    {
        key1: FiltroEmbarqueCompletoEnum.AdicionalEmpresa,
        title1: FiltroEmbarqueCompletoTitles.AdicionalEmpresa,
        key2: FiltroEmbarqueCompletoEnum.AdicionalMotorista,
        title2: FiltroEmbarqueCompletoTitles.AdicionalMotorista,
    },
    {
        key1: FiltroEmbarqueCompletoEnum.Classificacao,
        title1: FiltroEmbarqueCompletoTitles.Classificacao,
        key2: FiltroEmbarqueCompletoEnum.Km,
        title2: FiltroEmbarqueCompletoTitles.Km,
    },
    {
        key1: FiltroEmbarqueCompletoEnum.Embalagem,
        title1: FiltroEmbarqueCompletoTitles.Embalagem,
        key2: FiltroEmbarqueCompletoEnum.FreteFiscal,
        title2: FiltroEmbarqueCompletoTitles.FreteFiscal,
    },
    {
        key1: FiltroEmbarqueCompletoEnum.FreteMotorista,
        title1: FiltroEmbarqueCompletoTitles.FreteMotorista,
        key2: FiltroEmbarqueCompletoEnum.Icms,
        title2: FiltroEmbarqueCompletoTitles.Icms,
    },
    {
        key1: FiltroEmbarqueCompletoEnum.Margem,
        title1: FiltroEmbarqueCompletoTitles.Margem,
        key2: FiltroEmbarqueCompletoEnum.Motivo,
        title2: FiltroEmbarqueCompletoTitles.Motivo,
    },
    {
        key1: FiltroEmbarqueCompletoEnum.Observacao,
        title1: FiltroEmbarqueCompletoTitles.Observacao,
        key2: FiltroEmbarqueCompletoEnum.Pedagio,
        title2: FiltroEmbarqueCompletoTitles.Pedagio,
    },
];

export const numberFiltroEmbarque: {
    key: FiltroEmbarqueCompletoEnum;
    title: FiltroEmbarqueCompletoTitles;
}[] = [
    {
        key: FiltroEmbarqueCompletoEnum.PedidoIds,
        title: FiltroEmbarqueCompletoTitles.Pedido,
    },
    {
        key: FiltroEmbarqueCompletoEnum.MotoristaIds,
        title: FiltroEmbarqueCompletoTitles.Motorista,
    },
    {
        key: FiltroEmbarqueCompletoEnum.MercadoriaIds,
        title: FiltroEmbarqueCompletoTitles.Mercadoria,
    },
    {
        key: FiltroEmbarqueCompletoEnum.MeioPagamentoIds,
        title: FiltroEmbarqueCompletoTitles.MeioPagamento,
    },
    {
        key: FiltroEmbarqueCompletoEnum.ProprietarioIds,
        title: FiltroEmbarqueCompletoTitles.Proprietario,
    },
    {
        key: FiltroEmbarqueCompletoEnum.ClienteIds,
        title: FiltroEmbarqueCompletoTitles.Cliente,
    },
    {
        key: FiltroEmbarqueCompletoEnum.UnidEmbarqueIds,
        title: FiltroEmbarqueCompletoTitles.UnidadeEmbarque,
    },
    {
        key: FiltroEmbarqueCompletoEnum.PlacaCarretaIds,
        title: FiltroEmbarqueCompletoTitles.PlacaCarreta,
    },
    {
        key: FiltroEmbarqueCompletoEnum.PlacaCavaloIds,
        title: FiltroEmbarqueCompletoTitles.PlacaCavalo,
    },
    {
        key: FiltroEmbarqueCompletoEnum.PlacaCarreta2Ids,
        title: FiltroEmbarqueCompletoTitles.PlacaCarreta,
    },
    {
        key: FiltroEmbarqueCompletoEnum.CidadeDestinoIds,
        title: FiltroEmbarqueCompletoTitles.CidadeDestino,
    },
    {
        key: FiltroEmbarqueCompletoEnum.CidadeOrigemIds,
        title: FiltroEmbarqueCompletoTitles.CidadeOrigem,
    },
    {
        key: FiltroEmbarqueCompletoEnum.FilialIds,
        title: FiltroEmbarqueCompletoTitles.Filial,
    },
    {
        key: FiltroEmbarqueCompletoEnum.EmpresaIds,
        title: FiltroEmbarqueCompletoTitles.Empresa,
    },
    {
        key: FiltroEmbarqueCompletoEnum.TipoCarroceriaIds,
        title: FiltroEmbarqueCompletoTitles.TipoCarroceria,
    },
    {
        key: FiltroEmbarqueCompletoEnum.TipoVeiculoIds,
        title: FiltroEmbarqueCompletoTitles.TipoVeiculo,
    },
    {
        key: FiltroEmbarqueCompletoEnum.StatusIds,
        title: FiltroEmbarqueCompletoTitles.Status,
    },
];

export const combinedFiltroEmbarque: {
    keySelect: FiltroEmbarqueCompletoEnum;
    key: FiltroEmbarqueCompletoEnum;
    title: FiltroEmbarqueCompletoTitles;
}[] = [
    {
        keySelect: FiltroEmbarqueCompletoEnum.PedidoIds,
        key: FiltroEmbarqueCompletoEnum.Pedido,
        title: FiltroEmbarqueCompletoTitles.Pedido,
    },
    {
        keySelect: FiltroEmbarqueCompletoEnum.MotoristaIds,
        key: FiltroEmbarqueCompletoEnum.Motorista,
        title: FiltroEmbarqueCompletoTitles.Motorista,
    },
    {
        keySelect: FiltroEmbarqueCompletoEnum.ClienteIds,
        key: FiltroEmbarqueCompletoEnum.Cliente,
        title: FiltroEmbarqueCompletoTitles.Cliente,
    },
    {
        keySelect: FiltroEmbarqueCompletoEnum.MeioPagamentoIds,
        key: FiltroEmbarqueCompletoEnum.MeioPagamento,
        title: FiltroEmbarqueCompletoTitles.MeioPagamento,
    },
    {
        keySelect: FiltroEmbarqueCompletoEnum.ProprietarioIds,
        key: FiltroEmbarqueCompletoEnum.Proprietario,
        title: FiltroEmbarqueCompletoTitles.Proprietario,
    },
    {
        keySelect: FiltroEmbarqueCompletoEnum.MercadoriaIds,
        key: FiltroEmbarqueCompletoEnum.Mercadoria,
        title: FiltroEmbarqueCompletoTitles.Mercadoria,
    },
    {
        keySelect: FiltroEmbarqueCompletoEnum.UnidEmbarqueIds,
        key: FiltroEmbarqueCompletoEnum.UnidEmbarque,
        title: FiltroEmbarqueCompletoTitles.UnidadeEmbarque,
    },
    {
        keySelect: FiltroEmbarqueCompletoEnum.PlacaCarretaIds,
        key: FiltroEmbarqueCompletoEnum.PlacaCarreta,
        title: FiltroEmbarqueCompletoTitles.PlacaCarreta,
    },
    {
        keySelect: FiltroEmbarqueCompletoEnum.PlacaCavaloIds,
        key: FiltroEmbarqueCompletoEnum.PlacaCavalo,
        title: FiltroEmbarqueCompletoTitles.PlacaCavalo,
    },
    {
        keySelect: FiltroEmbarqueCompletoEnum.CidadeOrigemIds,
        key: FiltroEmbarqueCompletoEnum.CidadeOrigem,
        title: FiltroEmbarqueCompletoTitles.CidadeOrigem,
    },
    {
        keySelect: FiltroEmbarqueCompletoEnum.CidadeDestinoIds,
        key: FiltroEmbarqueCompletoEnum.CidadeDestino,
        title: FiltroEmbarqueCompletoTitles.CidadeDestino,
    },
    {
        keySelect: FiltroEmbarqueCompletoEnum.FilialIds,
        key: FiltroEmbarqueCompletoEnum.Filial,
        title: FiltroEmbarqueCompletoTitles.Filial,
    },
    {
        keySelect: FiltroEmbarqueCompletoEnum.EmpresaIds,
        key: FiltroEmbarqueCompletoEnum.Empresa,
        title: FiltroEmbarqueCompletoTitles.Empresa,
    },
    {
        keySelect: FiltroEmbarqueCompletoEnum.TipoCarroceriaIds,
        key: FiltroEmbarqueCompletoEnum.TipoCarroceria,
        title: FiltroEmbarqueCompletoTitles.TipoCarroceria,
    },
    {
        keySelect: FiltroEmbarqueCompletoEnum.TipoVeiculoIds,
        key: FiltroEmbarqueCompletoEnum.TipoVeiculo,
        title: FiltroEmbarqueCompletoTitles.TipoVeiculo,
    },
    {
        keySelect: FiltroEmbarqueCompletoEnum.StatusIds,
        key: FiltroEmbarqueCompletoEnum.Status,
        title: FiltroEmbarqueCompletoTitles.Status,
    },
];

export const headerFiltroEmbarque: {
    key: FiltroEmbarqueCompletoEnum;
    title: FiltroEmbarqueCompletoTitles;
}[] = [
    {
        key: FiltroEmbarqueCompletoEnum.Load,
        title: FiltroEmbarqueCompletoTitles.Load,
    },
    {
        key: FiltroEmbarqueCompletoEnum.Cte,
        title: FiltroEmbarqueCompletoTitles.Cte,
    },
    {
        key: FiltroEmbarqueCompletoEnum.Peso,
        title: FiltroEmbarqueCompletoTitles.Peso,
    },
    {
        key: FiltroEmbarqueCompletoEnum.Saldo,
        title: FiltroEmbarqueCompletoTitles.Saldo,
    },
];
